import { Component, Model, Prop, Vue } from 'nuxt-property-decorator';

import IconChevronDown from '../../assets/svg/chevron-down.svg';

@Component<Select>({
  components: {
    IconChevronDown
  },
  data() {
    return {
      value: this.modelValue
    };
  }
})
export default class Select extends Vue {
  @Model('change')
  modelValue!: any;

  @Prop()
  label!: string;

  @Prop()
  options!: any[];

  @Prop()
  placeholder!: string;

  // State
  @Prop({ type: Boolean, default: false })
  disabled!: boolean;

  @Prop({ type: Boolean, default: false })
  error!: boolean;

  highlight: boolean = false;

  get hasDescription(): boolean {
    return !!this.$slots.default;
  }

  updateInput(element: HTMLSelectElement): void {
    this.highlight = !!this.options[element.selectedIndex - 1].highlight;
    this.$emit('change', element.value);
  }
}
